import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { ProductSalesGroup } from 'src/app/assabil-kernel/models/entities/control-tables/product-sales-group';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductSalesGroupRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/product-sales-group-request';


@Component({
  selector: 'app-product-sales-group-list',
  templateUrl: './product-sales-group-list.component.html',
  styleUrls: ['./product-sales-group-list.component.scss']
})


export class ProductSalesGroupListComponent extends BasePage2<ProductSalesGroup> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  productSalesGroups: ProductSalesGroup[] = [];
  // ---------------------------------------------------
  
  //----------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName  = 'productSalesGroup';
  }
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------

  listFields = [
      { prop: 'productSalesGroupCode', name: 'Code',    insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang',                     type : 'number'},
  ]
  //----------------------------------------------------------------------

//----------------------------------------------------------------------
getRows(): ProductSalesGroup[] {
    return this.productSalesGroups;
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
    let entity : ProductSalesGroup = new ProductSalesGroup();
    entity.inserted = true;
    entity.edit = true;
    this.productSalesGroups.push(entity);
    this.productSalesGroups = [...this.productSalesGroups];
}
//----------------------------------------------------------------------

       
//----------------------------------------------------------------------
saveRow(productSalesGroup : ProductSalesGroup ): Promise<ProductSalesGroup> {
    let request  : ProductSalesGroupRequest = new ProductSalesGroupRequest(this.controlService.getUserInfo());
    request.productSalesGroup = productSalesGroup;
        return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------

  
//----------------------------------------------------------------------
  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;
    this.controlService.getList(this.entityName, request).then(result => {
        this.productSalesGroups = result;  
    })
  }
//----------------------------------------------------------------------


  }
